<script setup lang="ts">
import { onMounted, onUnmounted, ref } from 'vue'
import useConsentStore from '@scripts/stores/consent-store.js'
import { storeToRefs } from 'pinia'
import Consent from '@components/Consent.vue'

const { id, showCaption = true } = defineProps<{
    id: string
    showCaption?: boolean
}>()

const embed = ref<HTMLIFrameElement | null>(null)
const height = ref(320)
const consentStore = useConsentStore()
const { instagramEnabled } = storeToRefs(consentStore)

const src = `https://www.instagram.com/p/${id}/embed/${showCaption ? 'captioned' : ''}`

function onMessage(e: MessageEvent) {
    if (e.source !== embed.value?.contentWindow) {
        return
    }

    const payload = JSON.parse(e.data) as {
        type: 'LOADING' | 'MEASURE' | 'MOUNTED'
        details: any
    }

    if (payload.type === 'MEASURE') {
        height.value = payload.details.height
    }
}

onMounted(() => {
    window.addEventListener('message', onMessage)
})

onUnmounted(() => {
    window.removeEventListener('message', onMessage)
})
</script>

<template>
    <Consent
        aspect-ratio="1/1"
        source="Instagram"
        text="Dieser Beitrag wird von Instagram geladen."
        :enabled="instagramEnabled"
        @consent="() => (instagramEnabled = true)"
    >
        <iframe
            ref="embed"
            :src="src"
            class="w-full rounded border border-[#dbdbdb]"
            :height="height"
            title="Instagram Beitrag"
            scrolling="no"
        ></iframe>
    </Consent>
</template>
